import React, { forwardRef, useEffect, useRef, useState } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  DialogContent,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { motion } from "framer-motion";
import Feed from "../feed";
import CustomizedProgressBars from "../common/loading";
import AppSnackbar from "../common/appSnackbar.jsx";
import { useUser } from "../../contexts/userContext.jsx";
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { DOMAIN } from "../../config";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

export default function FavorDialog({ openSearch = false, setOpenSearch, matches, chipTitle }) {
  const [latest, setLatest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [empty, setEmpty] = useState(false);
  const [emptyMessage, setEmptyMessage] = useState("");
  const dialogRef = useRef(null);
  const { userData } = useUser();
  const touchStartRef = useRef(0);

  // 判断 remark 类型
  let isRemark = ["淫妻","淫妻绿帽","东京热","Sperm","夜未央","夜未央夫妻","周排行榜","科幻","ED Mosaic"].includes(chipTitle);

  // Touch 手势
  const handleSwipe = (event) => {
    const touchEndX = event.changedTouches[0].clientX;
    const swipeDistance = touchStartRef.current - touchEndX;
    if (swipeDistance > 120) setOpenSearch(false);
  };
  const handleTouchStart = (event) => {
    touchStartRef.current = event.touches[0].clientX;
  };

  const handleClose = () => setOpenSearch(false);

  // 获取初始收藏数据
  useEffect(() => {
    if (!openSearch) return;

    setLoading(true);
    const userId = window.Telegram.WebApp.initDataUnsafe?.user?.id;
    let url = "";

    if (userId) {
      url = `${DOMAIN}ywyminiappbot/favor?userid=${userId}&page=1`;
    } else if (userData?.username) {
      url = `${DOMAIN}ywyminiappbot/favorweb?username=${userData.username}&page=1`;
    } else {
      setEmpty(true);
      setEmptyMessage("请先登录");
      setLoading(false);
      return;
    }

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (!data || data.length === 0) {
          setEmpty(true);
          setEmptyMessage("您还未收藏任何视频");
          setLatest([]);
        } else {
          setEmpty(false);
          setLatest(data);
        }
      });
  }, [openSearch, userData]);

  // 构造 Feed 的 fetchUrl
  const userId = window.Telegram.WebApp.initDataUnsafe?.user?.id;
  const fetchUrl = userId
    ? `${DOMAIN}ywyminiappbot/favor?userid=${userId}`
    : `${DOMAIN}ywyminiappbot/favorweb?username=${userData?.username}`;

  return (
    <Box>
      <Dialog
        fullScreen
        open={openSearch}
        onClose={handleClose}
        TransitionComponent={Transition}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleSwipe}
        PaperProps={{
          onTouchStart: handleTouchStart,
          onTouchEnd: handleSwipe,
        }}
      >
        <AppSnackbar message={"向左 👈 滑动可快速关闭本页面"} vertical={"bottom"} />

        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            backgroundColor: "rgba(255,255,255,0.25)",
            color: "#000",
          }}
        >
          <Toolbar sx={{ minHeight: 45 }}>
            <motion.div
              initial={{ x: "100vw", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}
            >
              <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                <CloseIcon fontSize="small" />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, fontSize: 16 }} variant="h6" component="div">
                {chipTitle}
              </Typography>
            </motion.div>
          </Toolbar>
        </AppBar>

        <DialogContent
          ref={dialogRef}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            padding: 0,
            paddingTop: 45,
            overflowY: "auto",
          }}
        >
          {latest && latest.length > 0 && (
            <Feed
              matches={matches}
              latest={latest}
              setLatest={setLatest}
              title={"我的收藏"}
              remark={isRemark}
              chipTitle={"我的收藏"}
              fetchUrl={fetchUrl}
            />
          )}

          {loading && <CustomizedProgressBars />}

          {empty && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexFlow: "row",
                padding: "200px 0",
                color: "#999",
              }}
            >
              <SearchOffIcon />
              <Typography variant="h6" fontSize={14}>
                {emptyMessage}
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
